import React from "react";
import "./Navbar.css";
import logo from "../../assets/logo.png";

const Navbar = () => {
  return (
    <nav className="navbar">
      <img className="navbar-logo" src={logo} alt="Logo" />
      <ul className="navbar-links">
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#project">Project</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
        <li>
          <a
            href="https://drive.usercontent.google.com/download?id=1xbSlYAJwlziYHDQdM_iNAbHNRPEl_xkZ"
            download
          >
            Download
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
